import { useVoaRatingListStatus } from "@inrange/building-manager-api-client";
import { Badge, Spinner } from "react-bootstrap";
import CollapsibleCard from "../site/CollapsibleCard";

/**
 * "VOA data loaded" panel for Data & Config. Shows the freshness signal an
 * admin needs to decide whether to re-run the seed_voa_rating_list.py
 * script: current sourceRevision, last-seen timestamp, active row count.
 *
 * No interactive controls - the seed is run from the CLI (see
 * docs/design-unified-lead-pipeline.md "VOA refresh cadence").
 */
const VoaDataLoadedCard = () => {
  const status = useVoaRatingListStatus();

  return (
    <CollapsibleCard title="VOA rating list" initialOpen={false}>
      {status.isLoading && <Spinner animation="border" size="sm" />}
      {status.isError && (
        <p style={{ color: "#a00" }}>Failed to load VOA status.</p>
      )}
      {status.data && (
        <div style={{ fontSize: 13 }}>
          <p style={{ marginBottom: 4 }}>
            <strong>Current revision:</strong>{" "}
            {status.data.latestSourceRevision ? (
              <code>{status.data.latestSourceRevision}</code>
            ) : (
              <Badge bg="secondary">none</Badge>
            )}
          </p>
          <p style={{ marginBottom: 4 }}>
            <strong>Last loaded:</strong>{" "}
            {status.data.latestSeenAt
              ? new Date(status.data.latestSeenAt).toLocaleString()
              : "never"}
          </p>
          <p style={{ marginBottom: 4 }}>
            <strong>Active rows:</strong>{" "}
            {status.data.activeRowCount.toLocaleString()}
            {status.data.totalRowCount !== status.data.activeRowCount && (
              <span style={{ color: "#666" }}>
                {" "}
                ({status.data.totalRowCount.toLocaleString()} including
                removed)
              </span>
            )}
          </p>
          <p style={{ color: "#666", marginTop: 12, fontSize: 12 }}>
            VOA imports are run from the CLI when a new epoch is published.
            See <code>scripts/Y2026_Q2/seed_voa_rating_list.py</code> for the
            run command.
          </p>
        </div>
      )}
    </CollapsibleCard>
  );
};

export default VoaDataLoadedCard;
